import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionFigmaTeamAndProjects = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"type": "page",
			"properties": {
				"title": [
					[
						"Команды и проекты"
					]
				]
			},
			"content": [
				"9edb9380-0c06-47a7-8ee5-39eaeb010bfb",
				"caf59983-8d19-4928-8a60-8544b4356dc1",
				"b64ec498-4dd5-4321-aff9-ae75725acfc5",
				"71d0efd2-80f3-4071-a1d9-434529272033",
				"6fe34c59-cadf-4430-be09-bc8988075b59",
				"0ab5d291-f08a-432a-82c0-d8ccb3e75d20",
				"80525493-c058-4f36-8ada-fbfa58d07c88",
				"9f2a4b40-be33-4af2-8f57-b1f17fd592b7",
				"b2f098aa-72ab-42ef-85aa-4a3ee6dbe392",
				"3db41c4e-99b1-48e3-970c-4c6c9f8065bf",
				"e203f802-50ff-4ee0-89ba-c5336920f17e",
				"3e72cee4-3cb8-465e-91b5-a95ea0591293",
				"a6348cb2-47b8-4903-b8ee-130c9bbb78ce",
				"429030be-3ec3-4826-b5df-65a7e8f0ee0e",
				"9c41ae57-1e26-4a1d-87e1-4c7af5743b94",
				"12733b7e-b908-48b8-9664-35f2d4970fbf",
				"0dd0cb23-9fa4-4a08-8d3c-84ac85a10e50",
				"9b27bce8-87b4-4051-a50f-5bd96043d2b7",
				"c37c1b90-c5a6-4bde-890b-d85b3c25f31e",
				"7c3d351d-972e-4b13-9000-430c84251e0c",
				"26591de1-ea10-4d18-8ef5-a2e09506e17d",
				"c10e4007-5baf-4840-9d4c-81fd7cc19fe8",
				"9007d8da-95a9-4523-8ca9-68f243a6dd0c",
				"c6d5445d-d734-484f-b609-18d18a498e72",
				"114dd38e-5e09-4f0d-b50a-e0bf78b85040",
				"379c875a-2588-491a-a136-f9f073cb69cb",
				"3a2b16d3-8be3-4808-bdcc-567ca682e195",
				"135dc26c-a5ea-4c85-b2a1-bffa8d398211",
				"654942db-c363-456d-b307-967f71b42814",
				"4923aea0-ba24-406c-8537-681c227a3ff3",
				"33f6df80-ff3a-4450-9795-c9f54ddb5dd0",
				"d885e8f7-023b-4dfe-9807-9cdd87b48f8b",
				"36675131-ee87-4018-af02-8de0644f7e58"
			],
			"format": {
				"copied_from_pointer": {
					"id": "e158387b-08e9-4f99-909e-648672c061cf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"page_cover_position": 0.6
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"1758a578-b392-4c52-a7ca-6fb5cec76247"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9edb9380-0c06-47a7-8ee5-39eaeb010bfb",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/figma/team_and_projects\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "10dfb977-0896-41e6-83df-515717fd3460",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "caf59983-8d19-4928-8a60-8544b4356dc1",
			"type": "header",
			"properties": {
				"title": [
					[
						"Команды"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "18eeb9fc-cfd5-440f-a952-ed0a4ffef95c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b64ec498-4dd5-4321-aff9-ae75725acfc5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Команды в Figma VK организованы по продуктам, которые они разрабатывают. Вы можете вступить в любое количество команд и следить за работой коллег."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f7a40c80-89e5-4d63-bda4-5bcebd6fe57f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "71d0efd2-80f3-4071-a1d9-434529272033",
			"type": "image",
			"properties": {
				"size": [
					[
						"234.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9ac1c2f3-1962-41b8-99b4-495b19d9dee1/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9ac1c2f3-1962-41b8-99b4-495b19d9dee1/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7111111111111111,
				"block_preserve_scale": true
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"file_ids": [
				"9ac1c2f3-1962-41b8-99b4-495b19d9dee1"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/71d0efd2-80f3-4071-a1d9-434529272033.png"
		},
		{
			"id": "6fe34c59-cadf-4430-be09-bc8988075b59",
			"type": "header",
			"properties": {
				"title": [
					[
						"Проект"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "448ce992-b6cd-4ef4-9975-1930f0c9469e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ab5d291-f08a-432a-82c0-d8ccb3e75d20",
			"type": "text",
			"properties": {
				"title": [
					[
						"Проекты позволяют организовать хранение дизайн-документации наподобие папок в системе. При создании проекта убедитесь, что команда имеет к нему доступ для редактирования."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5c7845ef-2343-408d-acd4-6c61a1fd3b51",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "80525493-c058-4f36-8ada-fbfa58d07c88",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Типы проектов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3aac3d22-8918-4bed-9445-87cb3c5724e2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9f2a4b40-be33-4af2-8f57-b1f17fd592b7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для поддержания порядка и упрощения работы с проектами мы рекомендуем придерживаться определенных правил в наименовании категорий и добавлении смайлов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2c7dae49-0f6b-4b2a-beb7-b950ee69f7d7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b2f098aa-72ab-42ef-85aa-4a3ee6dbe392",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Desktop",
						[
							[
								"b"
							]
						]
					],
					[
						" — всё, что связано с web и мобильный веб"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a7f36a7e-fd36-4019-a5f8-56a28744cde8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3db41c4e-99b1-48e3-970c-4c6c9f8065bf",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"iOS",
						[
							[
								"b"
							]
						]
					],
					[
						" — для хранения экранов приложений и iPad"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ecc4d08d-fe65-46d6-a1eb-700782516390",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e203f802-50ff-4ee0-89ba-c5336920f17e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Android",
						[
							[
								"b"
							]
						]
					],
					[
						" — для Android-приложений"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2e006c33-c137-4b02-b9c5-95d0e36a4ff4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3e72cee4-3cb8-465e-91b5-a95ea0591293",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Design System",
						[
							[
								"b"
							]
						]
					],
					[
						" — для хранения ваших UI-китов и других технических файлов. Также в этой папке обычно находятся Master—файлы с ключевыми экранами продукта"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "98a87772-1c87-46e1-8a9e-cda4f9462a77",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a6348cb2-47b8-4903-b8ee-130c9bbb78ce",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Promo",
						[
							[
								"b"
							]
						]
					],
					[
						" — для промоматериалов, лендингов, писем"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "908b4f41-4fa9-47a1-b8b0-e64d591315b2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "429030be-3ec3-4826-b5df-65a7e8f0ee0e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Archive",
						[
							[
								"b"
							]
						]
					],
					[
						" — все неактуальные файлы и библиотеки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ba871094-12c1-4be1-8f2b-f91eb87523a0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9c41ae57-1e26-4a1d-87e1-4c7af5743b94",
			"type": "image",
			"properties": {
				"size": [
					[
						"230.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0660a0a6-e64e-45b9-b1ed-abc2f1b373bf/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0660a0a6-e64e-45b9-b1ed-abc2f1b373bf/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5533333333333333,
				"block_preserve_scale": true
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"file_ids": [
				"0660a0a6-e64e-45b9-b1ed-abc2f1b373bf"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9c41ae57-1e26-4a1d-87e1-4c7af5743b94.png"
		},
		{
			"id": "12733b7e-b908-48b8-9664-35f2d4970fbf",
			"type": "header",
			"properties": {
				"title": [
					[
						"Обложки файлов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bbaffd14-ff33-4a60-a927-0c19e3542863",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0dd0cb23-9fa4-4a08-8d3c-84ac85a10e50",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для продуктов дизайн-системы Paradigm разработан специальный компонент для обложек. Мы рекомендуем использовать его для своих продуктов. Компонент уже встроен в шаблоны новых задач, если нет обратитесь к вашему руководителю или Валере. Все настройки делаются через параметры компоненты, не нужно настраивать элементы вручную."
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9b27bce8-87b4-4051-a50f-5bd96043d2b7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Информация для отображения на обложке:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "275a7a01-8dd3-46ec-98ef-6ca3bc47f0e9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c37c1b90-c5a6-4bde-890b-d85b3c25f31e",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Аватар дизайнера ответственного за макет, может быть несколько. Номер задачи"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c3d351d-972e-4b13-9000-430c84251e0c",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Название проекта – текстовое краткое название фичи или задачи"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "26591de1-ea10-4d18-8ef5-a2e09506e17d",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Иконка продукта"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c10e4007-5baf-4840-9d4c-81fd7cc19fe8",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Тег платформы – есть теги для продукта и для промо. Можно использовать до 4 тегов"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9007d8da-95a9-4523-8ca9-68f243a6dd0c",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Изображение – если это поможет быстрее считать информацию из файла можно добавить изображение на обложку"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c6d5445d-d734-484f-b609-18d18a498e72",
			"type": "image",
			"properties": {
				"size": [
					[
						"102.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5356bb46-4068-4b55-8331-c4ac0c8cccf7/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5356bb46-4068-4b55-8331-c4ac0c8cccf7/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5477777777777778,
				"block_preserve_scale": true
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"file_ids": [
				"5356bb46-4068-4b55-8331-c4ac0c8cccf7"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c6d5445d-d734-484f-b609-18d18a498e72.png"
		},
		{
			"id": "114dd38e-5e09-4f0d-b50a-e0bf78b85040",
			"type": "text",
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "379c875a-2588-491a-a136-f9f073cb69cb",
			"type": "text",
			"properties": {
				"title": [
					[
						"Существуют три цветовые схемы обложек. Например, можно выделить дизайны продукта - черным, дизайны коммуникаций - белым, а дизайн исследований синим."
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3a2b16d3-8be3-4808-bdcc-567ca682e195",
			"type": "text",
			"properties": {
				"title": [
					[
						"Переключение цветов осуществляется инструментами Figma."
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "135dc26c-a5ea-4c85-b2a1-bffa8d398211",
			"type": "image",
			"properties": {
				"size": [
					[
						"91.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6f6b46eb-59f3-471e-88ab-53aa99b9b77c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6f6b46eb-59f3-471e-88ab-53aa99b9b77c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.24222222222222223,
				"block_preserve_scale": true
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"file_ids": [
				"6f6b46eb-59f3-471e-88ab-53aa99b9b77c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/135dc26c-a5ea-4c85-b2a1-bffa8d398211.png"
		},
		{
			"id": "654942db-c363-456d-b307-967f71b42814",
			"type": "text",
			"properties": {
				"title": [
					[
						"Изображения имеют 3 формата:"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4923aea0-ba24-406c-8537-681c227a3ff3",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Desktop - для этой версии ставим через fill изображения макетов для веба и десктопа соответственно"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "33f6df80-ff3a-4450-9795-c9f54ddb5dd0",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Mobile - для мобильной версии подойдут макеты приложения, тача, и промо на сплешах, шторках и тд."
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d885e8f7-023b-4dfe-9807-9cdd87b48f8b",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Promo - в часть промо ставим изображение на весь формат компонента"
					]
				]
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "36675131-ee87-4018-af02-8de0644f7e58",
			"type": "image",
			"properties": {
				"size": [
					[
						"305.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3250a956-2ebf-4a1b-9705-d9138bdd0070/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3250a956-2ebf-4a1b-9705-d9138bdd0070/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5078459343794579,
				"block_preserve_scale": true
			},
			"parent_id": "e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
			"parent_table": "block",
			"file_ids": [
				"3250a956-2ebf-4a1b-9705-d9138bdd0070"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/36675131-ee87-4018-af02-8de0644f7e58.png"
		}
	],
	"headers": [
		{
			"title": "Команды",
			"id": "caf59983-8d19-4928-8a60-8544b4356dc1"
		},
		{
			"title": "Проект",
			"id": "6fe34c59-cadf-4430-be09-bc8988075b59"
		},
		{
			"title": "Обложки файлов",
			"id": "12733b7e-b908-48b8-9664-35f2d4970fbf"
		}
	]
}} />
);

export default NotionFigmaTeamAndProjects;
